import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentMediaSource } from '../../_hocs/withCurrentMediaSource';
import { useCurrentGallection } from '../../_hocs/withCurrentGallection';
import { MediaSourceType } from '../../types';
import { showNewFolderPopup, hideNewFolderPopup } from '../../actions';
import { getCurrentUserHasCore } from '../../../publicSession/selectors';
import { isPremiumGallection } from '../../../utils/gallections';
import PlusIconWithTextButton from '../PlusIconWithTextButton';
import NewGallectionPopup from '../NewGallectionPopup';
import { getIsShowingNewGallectionPopup } from '../../selectors';
import { URLS } from '@wix/da-url';
import { useSelector } from 'react-redux';
import { useMMSelector, useMMDispatchActions, } from '../../_hocs/withOwnReduxStore';
export var AddGallectionButton = React.memo(function (_a) {
    var isSecondary = _a.isSecondary;
    var t = useTranslation().t;
    var hasCore = useSelector(function (state) { return ({
        hasCore: getCurrentUserHasCore(state),
    }); }).hasCore;
    var currentMediaSource = useCurrentMediaSource().currentMediaSource;
    var _b = useCurrentGallection(), currentGallection = _b.currentGallection, currentFolderId = _b.currentFolderId;
    var isShowingNewGallectionPopup = useMMSelector(function (state) { return ({
        isShowingNewGallectionPopup: getIsShowingNewGallectionPopup(state),
    }); }).isShowingNewGallectionPopup;
    var actions = useMMDispatchActions({
        showNewFolderPopup: showNewFolderPopup,
        hideNewFolderPopup: hideNewFolderPopup,
    });
    var buttonText = useMemo(function () {
        switch (currentMediaSource) {
            case MediaSourceType.STASH:
                return t('mediapopup.newStash');
            case MediaSourceType.GALLERY:
                if (isSecondary) {
                    return t('mediapopup.newGallery.newSubGallery');
                }
                return t('mediapopup.newGallery');
            case MediaSourceType.COLLECTION:
            default:
                if (isSecondary) {
                    return t('mediapopup.newCollection.newSubCollection');
                }
                return t('mediapopup.newCollection');
        }
    }, [currentMediaSource, isSecondary, t]);
    if (isPremiumGallection(currentGallection)) {
        // completely hidden
        return null;
    }
    var isForSubfolders = !!currentFolderId;
    var button = (React.createElement(PlusIconWithTextButton, { buttonView: isSecondary ? 'b3' : 'b14', onClick: actions.showNewFolderPopup, disabled: isForSubfolders && !hasCore, withCoreBanner: isForSubfolders && !hasCore, text: buttonText }));
    return (React.createElement(React.Fragment, null,
        isForSubfolders && !hasCore ? (React.createElement("a", { href: URLS.CORE_MEMBERSHIP, target: "_blank", rel: "noopener noreferrer" }, button)) : (button),
        isShowingNewGallectionPopup && (React.createElement(NewGallectionPopup, { onCancel: actions.hideNewFolderPopup, onDone: actions.hideNewFolderPopup }))));
});
AddGallectionButton.displayName = 'AddGallectionButton';
export default AddGallectionButton;
//# sourceMappingURL=AddGallectionButton.js.map